var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desc-block"},[_c('span',{staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":_vm.resolvedImagePath}}),_c('p',[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }